import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Routes, useParams } from 'react-router-dom';
import { setPageTitle } from 'store/actions/header';
import SlidingNav from 'app/shared/nav/sliding/sliding';

import { TenantWalletLogs } from './components/walletlogs';
import { TenantPaymentLogs } from './components/payments/payment-logs';
import TenantDashboard from './components/dashboard/dashboard';
import { TenantUpdatePage } from './components/edit';
import { Spacer } from 'app/member/layouts/generic';
import { TenantCampaigns } from './components/campaigns';
import { TenantMailLogs } from './components/maillog';
import { SubscriptionsListPage } from './components/subscription/list';
import { TenantUsers } from './components/users/index';

export const TenantPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const NAVITEMS = [
    {
      title: 'Overview',
      path: `/tenants/${id}/dashboard`
    },
    {
      title: 'Campaigns',
      path: `/tenants/${id}/campaigns`
    },
    {
      title: 'Subscriptions',
      path: `/tenants/${id}/subscriptions`
    },
    {
      title: 'Email logs',
      path: `/tenants/${id}/logs/email`
    },
    {
      title: 'Wallet logs',
      path: `/tenants/${id}/logs/wallet`
    },
    {
      title: 'Payments',
      path: `/tenants/${id}/logs/payment`
    },
    {
      title: 'Users',
      path: `/tenants/${id}/logs/users`
    }
  ];
  const [nav_items, setNavItems] = useState(NAVITEMS);

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'Tenants', path: '.' }]));

    setNavItems(NAVITEMS);
  }, [id]);

  return (
    <>
      <header>
        <SlidingNav nav_items={nav_items} />
      </header>
      <Spacer multiple={4} />
      <Routes>
        <Route path="edit" element={<TenantUpdatePage />} />
        <Route path="dashboard" element={<TenantDashboard />} />
        <Route path="campaigns" element={<TenantCampaigns />} />
        <Route path="subscriptions" element={<SubscriptionsListPage />} />
        <Route path="logs/email" element={<TenantMailLogs />} />
        <Route path="logs/wallet" element={<TenantWalletLogs />} />
        <Route path="logs/payment" element={<TenantPaymentLogs />} />
        <Route path="logs/users" element={<TenantUsers />} />
        <Route path="" element={<TenantDashboard />} />
      </Routes>
    </>
  );
};
